var map = {
	"./1.jpeg": 7416,
	"./2.jpg": 736,
	"./3.JPG": 8054,
	"./4.JPG": 2349,
	"./5.jpg": 7011,
	"./6.png": 4752,
	"./7.png": 1001,
	"./8.jpg": 522,
	"./9.png": 1111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6182;